import React, { useState } from 'react';
import {
  Fab,
  Tooltip,
  Box,
  IconButton,
  Typography,
  Paper,
  Fade,
  useMediaQuery,
  useTheme
} from '@mui/material';
import {
  WhatsApp as WhatsAppIcon,
  Close as CloseIcon
} from '@mui/icons-material';

const WhatsAppFloat = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const phoneNumber = '07838319700';
  const formattedNumber = '9647838319700'; // Iraq country code + number without leading 0
  const defaultMessage = 'مرحباً، أريد الاستفسار عن منتجاتكم في متجر الصادق للعدد';

  const handleWhatsAppClick = () => {
    const whatsappUrl = `https://wa.me/${formattedNumber}?text=${encodeURIComponent(defaultMessage)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleTooltipToggle = () => {
    if (isMobile) {
      setShowTooltip(!showTooltip);
    }
  };

  return (
    <>
      {/* WhatsApp Floating Button */}
      <Box
        sx={{
          position: 'fixed',
          bottom: { xs: 100, sm: 24 }, // Above mobile navigation and PWA prompt
          right: { xs: 16, sm: 24 }, // Changed from left to right
          zIndex: 1200,
        }}
      >
        <Tooltip
          title={
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                تواصل معنا عبر واتساب
              </Typography>
              <Typography variant="body2" sx={{ fontSize: '0.75rem', mt: 0.5 }}>
                {phoneNumber}
              </Typography>
            </Box>
          }
          placement="top"
          arrow
          open={!isMobile ? undefined : false} // Show tooltip on hover for desktop only
        >
          <Fab
            color="success"
            aria-label="WhatsApp Contact"
            onClick={handleWhatsAppClick}
            onTouchStart={handleTooltipToggle} // For mobile touch interaction
            sx={{
              backgroundColor: '#25D366', // WhatsApp green
              color: 'white',
              width: 56,
              height: 56,
              boxShadow: 3,
              animation: 'pulse 2s infinite',
              '&:hover': {
                backgroundColor: '#128C7E', // Darker WhatsApp green
                transform: 'scale(1.1)',
                transition: 'all 0.3s ease-in-out',
              },
              '@keyframes pulse': {
                '0%': {
                  boxShadow: '0 0 0 0 rgba(37, 211, 102, 0.7)',
                },
                '70%': {
                  boxShadow: '0 0 0 10px rgba(37, 211, 102, 0)',
                },
                '100%': {
                  boxShadow: '0 0 0 0 rgba(37, 211, 102, 0)',
                },
              },
            }}
          >
            <WhatsAppIcon sx={{ fontSize: 28 }} />
          </Fab>
        </Tooltip>
      </Box>

      {/* Mobile Tooltip Card */}
      {isMobile && (
        <Fade in={showTooltip} timeout={300}>
          <Paper
            elevation={4}
            sx={{
              position: 'fixed',
              bottom: 170,
              right: 16, // Changed from left to right to align with button
              left: 16,
              p: 2,
              borderRadius: 2,
              backgroundColor: 'background.paper',
              zIndex: 1201,
              maxWidth: 300,
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
                  تواصل معنا عبر واتساب
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem', mb: 1 }}>
                  {phoneNumber}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem', lineHeight: 1.3 }}>
                  للاستفسار عن المنتجات والأسعار
                </Typography>
              </Box>
              <IconButton
                size="small"
                onClick={() => setShowTooltip(false)}
                sx={{ ml: 1 }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
          </Paper>
        </Fade>
      )}
    </>
  );
};

export default WhatsAppFloat;
